import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Edit as EditIcon, Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { studentsApi, Student } from "../students/api";

const SessionRecordList: React.FC = () => {
  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [students, setStudents] = useState<Student[]>([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const fetchStudents = async (search?: string) => {
    setLoading(true);
    try {
      const res = await studentsApi.getAll({
        page: 1,
        limit: 50,
        search: search?.trim() || undefined,
      });
      setStudents(res.data || res.items || res);
      setSearched(!!search);
    } catch {
      setStudents([]);
      setSearched(!!search);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  const handleSearch = async () => {
    fetchStudents(query);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h5">Session Records</Typography>
      </Box>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
          sx={{ display: "flex", gap: 2, alignItems: "center" }}
        >
          <TextField
            fullWidth
            size="small"
            label="Search by Admission No, Scholar No, or Student Name"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon fontSize="small" sx={{ mr: 1 }} />,
            }}
          />
        </Box>
      </Paper>

      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Admission No</TableCell>
                <TableCell>Scholar No</TableCell>
                <TableCell>Student Name</TableCell>
                <TableCell>Class - Section</TableCell>
                <TableCell align="right">Manage</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {students.map((student) => (
                <TableRow key={student.id} hover>
                  <TableCell>{student.admissionNumber}</TableCell>
                  <TableCell>{student.scholarNumber}</TableCell>
                  <TableCell>
                    {student.firstName} {student.lastName}
                  </TableCell>
                  <TableCell>
                    {student.class?.name} - {student.section?.name}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() =>
                        navigate(
                          `/scholar-register/session-record/${student.id}/edit`,
                        )
                      }
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {!loading && students.length === 0 && searched && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No students found for this search.
                  </TableCell>
                </TableRow>
              )}
              {!loading && !searched && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Enter a search term to find a student.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
};

export default SessionRecordList;
